<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 pay-receive">
  <po-widget>
    <span class="po-font-text-bold">Pagar e Receber - 15 dias</span>
    <div class="icon-loading" *ngIf="loading && !errorApi">
      <app-loading-icon></app-loading-icon>
    </div>
    <div class="icon-loading" *ngIf="!loading && errorApi">
      <span class="po-icon po-icon-exclamation"></span>
    </div>
    <div class="po-md-12 po-text-center" *ngIf="!loading && errorApi">
      <div *ngIf="!loading && errorApi">
        <app-error [message]="message"></app-error>
      </div>
    </div>
    <div *ngIf="!loading && !errorApi">
      <fusioncharts width="100%" height="310" type="mscombi2d" [dataSource]="dataSource">
      </fusioncharts>
    </div>
  </po-widget>
</div>